// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderDesktop_header__fqoMV","left":"HeaderDesktop_left__SRXf_","right":"HeaderDesktop_right__2gqM0","logo":"HeaderDesktop_logo__1CGI7"};